import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LocatorIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M21.1602 16.1338L14.0003 12L21.1602 7.8662C21.6387 7.5898 21.8028 6.9785 21.5264 6.5C21.2491 6.021 20.6358 5.8574 20.1602 6.1338L13 10.2678V2C13 1.4478 12.5522 1 12 1C11.4478 1 11 1.4478 11 2V10.2678L3.8398 6.1338C3.3603 5.8569 2.7495 6.0215 2.4736 6.5C2.1977 6.9785 2.3613 7.5898 2.8398 7.8662L9.9997 12L2.8398 16.1338C2.3613 16.4102 2.1977 17.0215 2.4736 17.5C2.6591 17.8213 2.9951 18 3.3408 18C3.5102 18 3.6826 17.957 3.8398 17.8662L11 13.7322V22C11 22.5527 11.4478 23 12 23C12.5522 23 13 22.5527 13 22V13.7322L20.1602 17.8662C20.3174 17.957 20.4893 18 20.6592 18C21.0049 18 21.3408 17.8213 21.5264 17.5C21.8028 17.0215 21.6387 16.4102 21.1602 16.1338Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LocatorIcon.displayName = 'LocatorIcon';
